<template>
  <div class="detail">
    <h1>{{ list.title }}</h1>
    <span>技术：{{ list.content }}</span>
    <div class="img">
      <img
        :src="item"
        v-for="(item, index) in list.img"
        :key="index"
        :alt="item"
        style="border: 1px solid #ccc; margin: 5px auto"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "WorkspaceJsonDetail",

  data() {
    return {
      list: {},
    };
  },

  mounted() {
    this.list = this.$route.query.item;
  },

  methods: {},
};
</script>

<style lang="less" scoped>
.detail {
  flex: 3;
  box-sizing: border-box;
  background-color: #fff;
  padding: 20px;
  span {
    display: block;
    font-size: 17px;
    color: #999;
    margin-top: 10px;
    height: 40px;
    border-bottom: 1px solid #ccc;
  }
  .img {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    img {
      margin: 10px;
      margin-top: 10px;
      width: 90%;
    }
  }
}
</style>
